import { httpGet, httpPost, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getCustomizeFormUrl(filename) {
    return (
      `${this.apiEndpoint}/api/customize-form/${localStorage.getItem(
        "CLINIC"
      )}/` + filename
    );
  }

  getGenericFormList() {
    return [
      {
        _id: 0,
        formName: "手術同意書",
        fileName: "手術同意書.docx",
      },
      {
        _id: 1,
        formName: "安樂死同意書",
        fileName: "安樂死同意書.docx",
      },
      {
        _id: 2,
        formName: "動物診斷證明書",
        fileName: "動物診斷證明書.docx",
      },
      {
        _id: 3,
        formName: "自訂表單範例",
        fileName: "自訂表單範例.docx",
      },
    ];
  }

  getCustomizeFormList() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize-form/list`;
    return httpGet(apiUrl);
  }

  uploadCustomizeForm(upload) {
    let docxData = new FormData();
    docxData.append("docx", upload);

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize-form/file`;

    return httpPost(apiUrl, docxData);
  }

  createCustomizeForm(formName, fileName) {
    let data = { formName, fileName };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize-form/`;

    return httpPost(apiUrl, data);
  }

  deleteCustomizeForm(_id) {
    let data = { _id };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize-form/`;

    return httpDelete(apiUrl, data);
  }

  deleteCustomizeFormFile(filename) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/customize-form/file/${filename}`;

    return httpDelete(apiUrl);
  }
}
